var _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconScanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Scan_Icon",
    "data-name": "Scan Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scan",
    transform: "translate(1.791 1.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5780",
    "data-name": "Path 5780",
    d: "M17.649,18.721A1.054,1.054,0,0,0,18.7,17.665V15.976a.632.632,0,1,1,1.263,0v1.689a2.319,2.319,0,0,1-2.316,2.322H15.965a.633.633,0,0,1,0-1.267Z",
    transform: "translate(-2.387 -2.21)",
    fill: "#da291c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5781",
    "data-name": "Path 5781",
    d: "M17.649,4.267A1.054,1.054,0,0,1,18.7,5.322V7.011a.632.632,0,1,0,1.263,0V5.322A2.319,2.319,0,0,0,17.649,3H15.965a.633.633,0,0,0,0,1.267Z",
    transform: "translate(-2.387 0)",
    fill: "#da291c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5782",
    "data-name": "Path 5782",
    d: "M5.341,18.721a1.054,1.054,0,0,1-1.053-1.056V15.976a.632.632,0,1,0-1.263,0v1.689a2.319,2.319,0,0,0,2.316,2.322H7.025a.633.633,0,0,0,0-1.267Z",
    transform: "translate(-0.184 -2.21)",
    fill: "#da291c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5783",
    "data-name": "Path 5783",
    d: "M5.341,4.267A1.054,1.054,0,0,0,4.289,5.322V7.011a.632.632,0,1,1-1.263,0V5.322A2.319,2.319,0,0,1,5.341,3H7.025a.633.633,0,0,1,0,1.267Z",
    transform: "translate(-0.184 0)",
    fill: "#da291c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5784",
    "data-name": "Path 5784",
    d: "M18.419,11.862a.632.632,0,0,1-.631.633H2.632a.633.633,0,0,1,0-1.267H17.788A.632.632,0,0,1,18.419,11.862Z",
    transform: "translate(0 -1.473)",
    fill: "#da291c",
    fillRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScanner);
export default __webpack_public_path__ + "static/media/icon_scanner.d2fb542a574ff1709693c91cd8e6dba6.svg";
export { ForwardRef as ReactComponent };